<template>
  <b-modal
    id="modal-lg"
    ref="modal-detail"
    hide-footer
    centered
    size="xl"
    title="Semua BMD"
  >
    <div class="mb-2">
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end mb-1">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Cari</label>
            <b-form-input
              v-model="searchQuery"
              placeholder="Tekan Enter"
              type="text"
              class="d-inline-block"
              @keyup.enter="keyUpSearchDashboardSummary"
            />
          </div>
        </b-form-group>
      </div>
      <vue-good-table
        :columns="fields"
        :rows="dataTable"
        :search-options="{
          enabled: true,
          externalQuery: searchQuery,
        }"
        :pagination-options="{
          enabled: true,
          perPage: perPage,
          jumpFirstOrLast: true,
        }"
        :total-rows="totalRecords"
        :is-loading="!isShowDetail"
        mode="remote"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <!-- Column: aksi -->
          <span v-if="props.column.field === 'aksi'">
            aaa
            <!-- <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
              class="btn-icon"
              size="sm"
              @click="clickDetail(data)"
            >
              <feather-icon icon="SearchIcon" />
            </b-button> -->
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Menampilkan 1 hingga </span>
              <b-form-select
                v-model="perPage"
                :options="['10','25','50']"
                class="mx-1"
                @input="inputPerPage"
              />
              <span class="text-nowrap">
                dari {{ totalRecords }} entri
              </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="totalRecords"
                :per-page="perPage"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="changePage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </b-modal>
</template>
<script>
import { ref, watchEffect, watch } from '@vue/composition-api'
import { VueGoodTable } from 'vue-good-table'
import { propsBoolean, propsString } from '@/utils/propsTipeData'
import apiDaftarBmd from '@/composables/b/daftarBmd'
import { parserValue } from '@/libs/helper'

export default {
  setup(props, context) {
    const g = context.root

    const isShowModal = ref(false)
    const currentPage = ref(1)
    const perPage = ref(10)
    const totalRecords = ref(0)
    const perPageOptions = [10, 100, 1000]
    const searchQuery = ref('')
    const kolok = ref('')
    const isShowDetail = ref(false)

    const dataTable = ref([])

    watchEffect(() => {
      isShowModal.value = props.isShow
      kolok.value = props.kolokVal
    })

    const getListBmd = async () => {
      isShowDetail.value = false

      const data = {
        filter_kolok: kolok.value,
        limit: perPage.value,
        start: (currentPage.value - 1) * perPage.value,
        cari: searchQuery.value,
      }
      const { rows, totalRows } = await apiDaftarBmd.getDataBmdPendalamanPendataan(g, data)
      dataTable.value = rows.map(item => ({ ...item, harga_oleh: new Intl.NumberFormat('id-ID').format(item.harga_oleh), tgl_oleh: parserValue('dateOnly', item.tgl_oleh) }))
      totalRecords.value = totalRows
      isShowDetail.value = true
    }

    watch(kolok, () => {
      dataTable.value = []
      currentPage.value = 1
      perPage.value = 10
      searchQuery.value = ''

      getListBmd()
    })

    watch(isShowModal, () => {
      context.refs['modal-detail'].show()
    })

    const changePage = () => {
      getListBmd()
    }

    const inputPerPage = () => {
      getListBmd()
    }

    const keyUpSearchDashboardSummary = () => {
      getListBmd()
    }

    return {
      currentPage,
      perPage,
      totalRecords,
      perPageOptions,
      searchQuery,
      dataTable,
      isShowDetail,

      changePage,
      inputPerPage,
      keyUpSearchDashboardSummary,
    }
  },
  components: { VueGoodTable },
  props: {
    isShow: propsBoolean,
    kolokVal: propsString,
  },
  data() {
    return {
      fields: [
        {
          label: 'Guid ID',
          field: 'guid_aset',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'kolok',
          field: 'kolok',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'nalok',
          field: 'nalok',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kobar',
          field: 'kobar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nabar',
          field: 'nabar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Harga',
          field: 'harga_oleh',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'merk',
          field: 'merk',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'tipe',
          field: 'tipe',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'No. Chasis/Rangka',
          field: 'nochasis',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'No. Mesin/Pabrik',
          field: 'nomesin',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'No. Polisi',
          field: 'nopol',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'No. BPKB',
          field: 'nobpkb',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status_hasil_sensus',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Tanggal Oleh',
          field: 'tgl_oleh',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
